import getCookies from '@/config/get-cookies'

export const isSSOEnabled = (country) => {
  const GOOGLE_SSO_COUNTRY = process.env[`VUE_APP_GOOGLE_SSO_${country}`]
  return GOOGLE_SSO_COUNTRY === 'true' || getCookies.get('test_sso_cookie') === 'true'
}

export default {
  isSSOEnabled
}
